import i18n from 'i18next';
import i18nBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

const getCurrentHost = process.env.REACT_APP_LANGUAGE_FILE_PATH ? process.env.REACT_APP_LANGUAGE_FILE_PATH.trim() + '/' : '';

i18n
  .use(i18nBackend)
  .use(initReactI18next)
  .init({
    //supported langs
    fallbackLng: ['en', 'tr', 'fr', 'de', 'ru'],
    //default lang
    lng: 'en',
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: `.${process.env.PUBLIC_URL}/i18n/${getCurrentHost}{{lng}}.json`,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
